import dayjs from 'dayjs';
export const activityTimeFormat = (startTime = 0, endTime = 0, showYear = false) => {
  if (!startTime || !endTime) {
    return '';
  }
  const sTime = dayjs(startTime * 1000);
  const eTime = dayjs(endTime * 1000);
  const isSameDay = eTime.isSame(sTime, 'day');
  const isSameYear = eTime.isSame(sTime, 'year');
  const yearStr = 'YYYY年MM月DD日 HH:mm';
  if (!isSameYear) {
    const formatStr = 'YYYY年MM月DD日 HH:mm';
    return `${sTime.format(formatStr)}-${eTime.format(formatStr)}`;
  }
  const formatStr = 'MM月DD日 HH:mm';
  if (showYear) {
    return `${sTime.format(yearStr)}-${eTime.format(formatStr)}`;
  }
  if (!isSameDay) {
    return `${sTime.format(formatStr)}-${eTime.format(formatStr)}`;
  }
  return `${sTime.format('MM月DD日 HH:mm')}-${eTime.format('HH:mm')}`;
};